import { useAppLifeCycle } from 'shared/src/hooks';
import { useEffect, useState } from 'react';
import { bridge, isNotNil, useAsyncEffect } from 'shared/src/utils';
import { useGoodsDetail } from '../queries/useGoodsDetail';

export const useIsFavoriteMarket = () => {
  const { lifeCycle } = useAppLifeCycle();
  const { data: goodsDetail } = useGoodsDetail();

  const [isFavoriteMarket, setIsFavoriteMarket] = useState(
    goodsDetail?.goods.market.is_favorite ?? false,
  );
  //
  useAsyncEffect(async () => {
    if (!goodsDetail) {
      return;
    }
    if (lifeCycle === 'viewWillAppear') {
      const localMarketLike = await bridge.getLocalMarketFavorite();

      if (isNotNil(localMarketLike)) {
        const localFavorite = localMarketLike[goodsDetail.goods.market.sno];
        if (isNotNil(localFavorite)) {
          setIsFavoriteMarket(localFavorite);
        }
      }
    }
  });

  useEffect(() => {
    if (goodsDetail) {
      setIsFavoriteMarket(goodsDetail?.goods.market.is_favorite ?? false);
    }
  }, [goodsDetail]);

  return {
    isFavoriteMarket,
  };
};
